import { sample } from 'effector'
import { fx } from 'src/libs'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { Strategy } from 'src/pages/copytrade/strategies/list/types'
import { setStrategy } from 'src/pages/copytrade/strategies/details/model'

export const updateAdditionalInvestorsFx = fx<
  { numAdditionalInvestors: number },
  Strategy
>({
  method: 'POST',
})

sample({
  clock: updateAdditionalInvestorsFx.doneData,
  fn: (doneData) => doneData.body,
  target: setStrategy,
})

sample({
  clock: updateAdditionalInvestorsFx.doneData,
  fn: (): NotificationPayload => {
    return {
      type: 'success',
      message: 'Request success',
      description: 'Added investors updated successfully.',
    }
  },
  target: showNotification,
})

sample({
  clock: updateAdditionalInvestorsFx.failData,
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})
